export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100/50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[640px] mx-auto text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-primary-100/70 text-primary-500 mx-auto mb-5">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
            如果您有蜜桃动漫在线资源推荐、投稿合作或意见建议，欢迎通过以下方式与我们取得联系。羞羞动漫在线观看团队将尽快回复您的讯息。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:contact@xiuxiudongman.example.com"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              发送邮件咨询
            </a>
            <span className="flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-time-line"></i>
              工作日 9:00-18:00 在线响应
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}